import {ref} from "vue";
import {defineStore} from "pinia";
import {IDriver} from "@/interfaces/IDriver";

export const useDriverStore = defineStore('drivers', () => {
    const drivers = ref<IDriver[]>([]);

    // Обновление техник
    const updateDrivers = (driverList: any []) => {
        const preventDrivers: IDriver[] = [];
        driverList.forEach((driver: any) => {
            preventDrivers.push({
                id: driver.driver_id,
                name: driver.driver_name,
            })
        });

        drivers.value = preventDrivers;
    };

    return {
        drivers,
        updateDrivers,
    };
});